;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import React from 'react';

function LinkedIn({ className }: { className?: string }) {
  return (
    <svg
      id="Share_button_liinkedin"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      className={className || ''}
    >
      <circle id="Ellipse_5" data-name="Ellipse 5" cx="16" cy="16" r="16" fill="#007fb1" />
      <path
        id="linkedin-in-brands"
        d="M3.358,15.01H.248V5h3.11ZM1.8,3.629A1.81,1.81,0,1,1,3.6,1.811,1.816,1.816,0,0,1,1.8,3.629ZM15,15.01h-3.1V10.135c0-1.162-.023-2.652-1.617-2.652-1.617,0-1.865,1.262-1.865,2.568V15.01H5.306V5H8.288V6.361h.044a3.268,3.268,0,0,1,2.942-1.617C14.422,4.744,15,6.817,15,9.509v5.5Z"
        transform="translate(9 7.99)"
        fill="#fff"
      />
    </svg>
  );
}

export default LinkedIn;
